var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"link-tag",attrs:{"href":_vm.link,"target":"_blank"}},[_vm._t("default"),_c('i',{staticClass:"bx bx-link-external bx-5"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }